!(function () {
    "use strict";
    var e = {
            208: function () {
                window.addEventListener("DOMContentLoaded", () => {
                    xoGroup.on("change", ({ element: e, index: t }) => {
                        const s = document.querySelectorAll(".filters-content__grid"),
                            n = document.querySelector("xo-filters-content");
                        let i = Number(e.innerHTML);
                        s?.forEach((e) =>
                            e.setAttribute(
                                "style",
                                `--xs: {{ columns_mobile }}; --sm: {{ columns_mobile }}; --md: {{ columns_desktop | minus: 1 }};--lg:${i}`
                            )
                        ),
                            n &&
                                n.handleContent((e) => {
                                    const t = new DOMParser().parseFromString(e, "text/html"),
                                        s = t.querySelectorAll(".filters-content__grid");
                                    return (
                                        s?.forEach((e) =>
                                            e.setAttribute(
                                                "style",
                                                `--xs: {{ columns_mobile }}; --sm: {{ columns_mobile }}; --md: {{ columns_desktop | minus: 1 }};--lg:${i}`
                                            )
                                        ),
                                        t.body.innerHTML
                                    );
                                });
                    });
                });
            },
            439: function () {
                let e = null;
                cartSubscribe((t) => {
                    const s = document.querySelector("#xo-notify");
                    if (null !== e && t.size > e && s) {
                        s.classList.add("cart-drawer-hidden");
                        const e = setTimeout(() => {
                            s.classList.remove("cart-drawer-hidden"), clearTimeout(e);
                        }, 3e3);
                    }
                    e = t.size;
                });
            },
        },
        t = {};
    function s(n) {
        var i = t[n];
        if (void 0 !== i) return i.exports;
        var o = (t[n] = { exports: {} });
        return e[n](o, o.exports, s), o.exports;
    }
    function n(e, t) {
        for (let s = 0; s < e.length; s++) t(e[s], s, e);
    }
    function i(e, t) {
        var s;
        n(((s = e), Object.keys(s)), (s) => {
            customElements.get(s) || customElements.define(s, e[s], t);
        });
    }
    function o(e = 0) {
        return new Promise((t) => {
            const s = window.setTimeout(() => {
                t(() => window.clearTimeout(s)), clearTimeout(s);
            }, e);
        });
    }
    function r(e) {
        /comp|inter/.test(document.readyState)
            ? e()
            : "addEventListener" in document
              ? document.addEventListener("DOMContentLoaded", e)
              : document.attachEvent("onreadystatechange", () => {
                    "complete" === document.readyState && e();
                });
    }
    new (class {
        frameId;
        keepAliveFrameId;
        lastTimestamp;
        frames;
        keepAliveFrames;
        defaultTimestep;
        constructor() {
            (this.frameId = null),
                (this.keepAliveFrameId = null),
                (this.lastTimestamp = null),
                (this.frames = []),
                (this.keepAliveFrames = []),
                (this.defaultTimestep = (1 / 60) * 1e3);
        }
        handleFrameLoop = (e) => {
            if (this.lastTimestamp) {
                const t = e - this.lastTimestamp;
                n(this.keepAliveFrames, (s) => s.call(this, { delta: t, timestamp: e }));
            }
            (this.lastTimestamp = e),
                this.keepAliveFrameId && cancelAnimationFrame(this.keepAliveFrameId),
                (this.keepAliveFrameId = requestAnimationFrame(this.handleFrameLoop));
        };
        handleFrame = (e) => {
            n(this.frames, (t) => t.call(this, { delta: this.defaultTimestep, timestamp: e }));
        };
        getFrames = () => this.frames;
        add = (e, t = !1) => (
            this.cancelFrame(),
            this.frames.includes(e) || this.frames.push(e),
            t && !this.keepAliveFrames.includes(e) && this.keepAliveFrames.push(e),
            this.start(),
            this
        );
        start = () => {
            (this.frameId = requestAnimationFrame(this.handleFrame)),
                (this.keepAliveFrameId = requestAnimationFrame(this.handleFrameLoop));
        };
        cancelFrame = () => {
            null != this.frameId && (cancelAnimationFrame(this.frameId), (this.frameId = null)),
                null != this.keepAliveFrameId &&
                    (cancelAnimationFrame(this.keepAliveFrameId), (this.keepAliveFrameId = null));
        };
        stopFrame = (e, t) => {
            const s = e.indexOf(t);
            -1 !== s && e.splice(s, 1), 0 === e.length && (this.cancelFrame(), (this.lastTimestamp = null));
        };
        remove = (e) => (this.stopFrame(this.frames, e), this.stopFrame(this.keepAliveFrames, e), this);
        clear = () => (
            (this.frames = []), (this.keepAliveFrames = []), this.cancelFrame(), (this.lastTimestamp = null), this
        );
    })();
    const a = function (e) {
        return e.replace(/([-]\w)/g, (e) => e[1].toUpperCase());
    };
    function l(e) {
        const t = e.trim();
        if (!/^{|\[/g.test(t)) return {};
        try {
            const e = new Function(`return ${t}`)();
            return JSON.parse(JSON.stringify(e));
        } catch {
            return /^\[/g.test(t) ? [] : {};
        }
    }
    function c(e, t) {
        switch (t) {
            case "string":
            default:
                return e;
            case "number":
                return Number(e);
            case "string | number": {
                const t = Number(e);
                return isNaN(t) ? e : t;
            }
            case "boolean":
                return "true" === e || "" === e;
            case "object":
            case "array":
                return l(e);
        }
    }
    navigator.userAgent.match(/Android/i),
        navigator.userAgent.match(/BlackBerry/i),
        navigator.userAgent.match(/iPad/i),
        navigator.userAgent.match(/iPhone|iPad|iPod/i),
        navigator.userAgent.match(/Opera Mini/i),
        navigator.userAgent.match(/Windows Phone/i),
        navigator.userAgent.match(/(?:SD4930UR|\\bSilk(?:.+)Mobile\\b)/i),
        navigator.userAgent.match(/Silk/i);
    const u = !!navigator.userAgent.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|Windows Phone|(?:SD4930UR|\bSilk(?:.+)Mobile\b)|Silk/i
    );
    function d(e) {
        const t = e?.ownerDocument,
            s = t.documentElement,
            n = (function (e) {
                return 9 === e.nodeType && e.defaultView;
            })(t);
        let i = { top: 0, left: 0 };
        return t
            ? (void 0 !== e.getBoundingClientRect && (i = e.getBoundingClientRect()),
              { top: i.top + n.scrollY - s.clientTop, left: i.left + n.scrollX - s.clientLeft })
            : { top: 0, left: 0 };
    }
    r(() => {
        const e = document.documentElement;
        u ? e.classList.add("is-mobile") : e.classList.add("is-desktop");
    });
    class h {
        dx;
        dy;
        vx = 0;
        vy = 0;
        isStart = !1;
        startX = 0;
        startX2 = 0;
        startY = 0;
        startY2 = 0;
        options;
        constructor(e) {
            (this.options = e),
                (this.dx = e.dx || 0),
                (this.dy = e.dy || 0),
                e.element.addEventListener("mousedown", this.handleMouseDown),
                u && e.element.addEventListener("touchstart", this.handleMouseDown);
        }
        handleMouseDown = (e) => {
            const { onStart: t } = this.options;
            if ("touchstart" === e.type && e.touches.length > 1) return;
            if ("mousedown" === e.type && 0 !== e.button) return;
            const s = e.target;
            u || (!s.closest("a") && !s.closest("img")) || e.preventDefault(),
                (this.isStart = !0),
                "touchstart" === e.type
                    ? ((this.startX = e.touches[0].clientX),
                      (this.startY = e.touches[0].clientY),
                      (this.startX2 = e.touches[0].clientX),
                      (this.startY2 = e.touches[0].clientY))
                    : ((this.startX = e.clientX),
                      (this.startY = e.clientY),
                      (this.startX2 = e.clientX),
                      (this.startY2 = e.clientY)),
                t?.(e),
                document.addEventListener("mousemove", this.handleMouseMove),
                document.addEventListener("touchmove", this.handleMouseMove, { passive: !1 }),
                document.addEventListener("mouseup", this.handleMouseUp),
                document.addEventListener("touchend", this.handleMouseUp);
        };
        handleMouseMove = (e) => {
            const { onMove: t } = this.options;
            if ("touchmove" === e.type && e.touches.length > 1) return;
            if ("mousemove" === e.type && 0 !== e.button) return;
            if ((u || e.preventDefault(), !this.isStart)) return;
            let s, n;
            "touchmove" === e.type
                ? ((s = e.touches[0].clientX), (n = e.touches[0].clientY))
                : ((s = e.clientX), (n = e.clientY));
            const i = s - this.startX,
                o = n - this.startY;
            (this.startX = s),
                (this.startY = n),
                (this.dx += i),
                (this.dy += o),
                (this.vx = i),
                (this.vy = o),
                t?.(
                    {
                        dx: this.dx,
                        dy: this.dy,
                        vx: this.vx,
                        vy: this.vy,
                        isHorizontalSwipe: Math.abs(s - this.startX2) > Math.abs(n - this.startY2),
                    },
                    e
                );
        };
        handleEnd = (e, t) => {
            const { onEnd: s } = this.options;
            this.isStart &&
                ((this.isStart = !1),
                t && ((this.dx = t.dx), (this.dy = t.dy), (this.vx = t.vx), (this.vy = t.vy)),
                s?.({ dx: this.dx, dy: this.dy, vx: this.vx, vy: this.vy }, e),
                document.removeEventListener("mousemove", this.handleMouseMove),
                document.removeEventListener("touchmove", this.handleMouseMove),
                document.removeEventListener("mouseup", this.handleMouseUp),
                document.removeEventListener("touchend", this.handleMouseUp));
        };
        handleMouseUp = (e) => {
            u || e.preventDefault(), this.handleEnd(e);
        };
        setValue = ({ dx: e, dy: t }) => {
            null != e && (this.dx = e), null != t && (this.dy = t);
        };
        destroy = () => {
            this.options.element.removeEventListener("mousedown", this.handleMouseDown),
                this.options.element.removeEventListener("touchstart", this.handleMouseDown),
                document.removeEventListener("mousemove", this.handleMouseMove),
                document.removeEventListener("touchmove", this.handleMouseMove),
                document.removeEventListener("mouseup", this.handleMouseUp),
                document.removeEventListener("touchend", this.handleMouseUp);
        };
    }
    !(function () {
        let e = !1;
        (() => {
            if (!e) {
                e = !0;
                const t = "@xoLocalStorageCheck";
                try {
                    return window.localStorage.setItem(t, t), window.localStorage.removeItem(t), !0;
                } catch {
                    return !1;
                }
            }
            return !0;
        })() && window.localStorage;
    })(),
        HTMLElement,
        r(() => {
            const e = document.getElementById("popup-newsletter__modal"),
                t = e?.getAttribute("data-show"),
                s = localStorage.getItem("popup-newsletter-last-shown"),
                n =
                    60 *
                    parseInt(document.getElementById("popup-newsletter-data__cooldown")?.textContent || "0", 10) *
                    1e3,
                i = window.location.pathname;
            e &&
                "hidden" != t &&
                ("all" === t || ("home" === t && i.includes("pages/home")) || "/" === i) &&
                (!s || Date.now() - parseInt(s, 10) >= n) &&
                (o(2e3).then(() => {
                    xoModal.open("popup-newsletter");
                }),
                localStorage.setItem("popup-newsletter-last-shown", Date.now().toString()));
        }),
        o(18e5).then(() => {
            xoModal.close("popup-newsletter");
        }),
        r(() => {
            const e = document.getElementById("popup-promotion__modal"),
                t = e?.getAttribute("data-show"),
                s = localStorage.getItem("popup-promotion-last-shown"),
                n =
                    60 *
                    parseInt(document.getElementById("popup-promotion-data__cooldown")?.textContent || "0", 10) *
                    1e3,
                i = window.location.pathname;
            e &&
                "hidden" != t &&
                ("all" === t || ("home" === t && i.includes("pages/home")) || "/" === i) &&
                (!s || Date.now() - parseInt(s, 10) >= n) &&
                (o(2e3).then(() => {
                    xoModal.open("popup-promotion");
                }),
                localStorage.setItem("popup-promotion-last-shown", Date.now().toString()));
        }),
        o(18e5).then(() => {
            xoModal.close("popup-promotion");
        }),
        s(439);
    const p = "xo-currency-select";
    class m extends HTMLElement {
        inputEls = [];
        formEl = null;
        constructor() {
            super(),
                (this.inputEls = Array.from(
                    this.querySelectorAll(".xo-currency-select__content .xo-currency-select__input")
                )),
                (this.formEl = this.querySelector(".xo-currency-select__form"));
        }
        handleChange = () => {
            this.formEl?.submit();
        };
        connectedCallback() {
            n(this.inputEls, (e) => {
                e.addEventListener("input", this.handleChange);
            });
        }
        disconnectedCallback() {
            n(this.inputEls, (e) => {
                e.removeEventListener("input", this.handleChange);
            });
        }
    }
    i({ [p]: m });
    const v = "xo-language-select";
    class f extends HTMLElement {
        inputEls = [];
        formEl = null;
        constructor() {
            super(),
                (this.inputEls = Array.from(
                    this.querySelectorAll(".xo-language-select__content .xo-language-select__input")
                )),
                (this.formEl = this.querySelector(".xo-language-select__form"));
        }
        handleChange = () => {
            this.formEl?.submit();
        };
        connectedCallback() {
            n(this.inputEls, (e) => {
                e.addEventListener("input", this.handleChange);
            });
        }
        disconnectedCallback() {
            n(this.inputEls, (e) => {
                e.removeEventListener("input", this.handleChange);
            });
        }
    }
    function y() {
        const e = document.querySelector(".xo-menu-horizontal-v1--click"),
            t = Array.from(e?.querySelectorAll(".xo-menu-horizontal-v1__link") ?? []);
        n(t, (e) => {
            const s = e.parentElement;
            (s.querySelector(".xo-menu-horizontal-v1__sub-menu") ||
                s.querySelector(".xo-menu-horizontal-v1__mega-menu")?.innerHTML.trim()) &&
                e.addEventListener("click", (s) => {
                    s.preventDefault();
                    const i = e.parentElement,
                        o = i?.parentElement?.closest(".xo-menu-horizontal-v1__item--click");
                    n(t, (e) => {
                        const t = e.parentElement;
                        t?.classList.contains("xo-menu-horizontal-v1__item--click") &&
                            t !== i &&
                            t?.classList.remove("xo-menu-horizontal-v1__item--open");
                    }),
                        i?.classList.contains("xo-menu-horizontal-v1__item--click") &&
                            i?.classList.toggle("xo-menu-horizontal-v1__item--open"),
                        o?.classList.add("xo-menu-horizontal-v1__item--open");
                });
        }),
            window.addEventListener("click", (s) => {
                e?.contains(s.target) ||
                    n(t, (e) => {
                        const t = e.parentElement;
                        t?.classList.remove("xo-menu-horizontal-v1__item--open");
                    });
            });
    }
    i({ [v]: f }),
        y(),
        window.Shopify.designMode &&
            document.addEventListener("shopify:section:load", (e) => {
                e.target.querySelector(".xo-menu-horizontal-v1") && y();
            });
    const g = document.querySelector(".xo-menu-scroll"),
        b = g?.querySelector(".xo-menu-scroll__list"),
        _ = Array.from(g?.querySelectorAll(".xo-menu-scroll__link") ?? []),
        E = g?.querySelector(".xo-menu-scroll__link--current");
    let S = !1,
        w = 0;
    if (b && E) {
        const { left: ue } = d(E),
            { left: de } = d(b);
        if ((b.scrollTo({ left: ue - de - (b.offsetWidth - E.offsetWidth) / 2 }), !u)) {
            const he = new h({
                element: b,
                onStart: () => {
                    (S = !0), (w = b.scrollLeft);
                },
                onMove: ({ dx: e }) => {
                    b.scrollTo({ left: w - e });
                },
                onEnd: () => {
                    (S = !1), he.setValue({ dx: 0 });
                },
            });
            function pe(e) {
                !S && e.preventDefault();
            }
            n(_, (e) => {
                e.addEventListener("click", pe);
            });
        }
    }
    function A() {
        var e = Error.call(this);
        return (e.name = "Server error"), (e.message = "Something went wrong on the server"), (e.status = 500), e;
    }
    function x(e) {
        var t = Error.call(this);
        return (t.name = "Not found"), (t.message = "Not found"), (t.status = e), t;
    }
    function L() {
        var e = Error.call(this);
        return (e.name = "Server error"), (e.message = "Something went wrong on the server"), (e.status = 500), e;
    }
    function k(e) {
        var t = Error.call(this);
        return (
            (t.name = "Content-Type error"),
            (t.message = "Content-Type was not provided or is of wrong type"),
            (t.status = e),
            t
        );
    }
    function T(e) {
        var t = Error.call(this);
        return (t.name = "JSON parse error"), (t.message = "JSON syntax error"), (t.status = e), t;
    }
    function I(e, t, s, n) {
        var i = Error.call(this);
        return (i.name = t), (i.message = s), (i.status = e), (i.retryAfter = n), i;
    }
    function C(e, t, s) {
        var n = Error.call(this);
        return (n.name = t), (n.message = s), (n.status = e), n;
    }
    function M(e, t, s) {
        var n = Error.call(this);
        return (n.name = t), (n.message = s), (n.status = e), n;
    }
    function O() {
        this.events = {};
    }
    function F(e) {
        (this.eventName = e), (this.callbacks = []);
    }
    function R(e) {
        (this._store = {}),
            (this._keys = []),
            e && e.bucketSize ? (this.bucketSize = e.bucketSize) : (this.bucketSize = 20);
    }
    function D(e, t) {
        var s = "";
        return (
            (t = t || null),
            Object.keys(e).forEach(function (n) {
                var i = n + "=";
                switch (
                    (t && (i = t + "[" + n + "]"),
                    (function (e) {
                        return Object.prototype.toString.call(e).slice(8, -1).toLowerCase();
                    })(e[n]))
                ) {
                    case "object":
                        s += D(e[n], t ? i : n);
                        break;
                    case "array":
                        s += i + "=" + e[n].join(",") + "&";
                        break;
                    default:
                        t && (i += "="), (s += i + encodeURIComponent(e[n]) + "&");
                }
            }),
            s
        );
    }
    (O.prototype.on = function (e, t) {
        var s = this.events[e];
        s || ((s = new F(e)), (this.events[e] = s)), s.registerCallback(t);
    }),
        (O.prototype.off = function (e, t) {
            var s = this.events[e];
            s &&
                s.callbacks.indexOf(t) > -1 &&
                (s.unregisterCallback(t), 0 === s.callbacks.length && delete this.events[e]);
        }),
        (O.prototype.dispatch = function (e, t) {
            var s = this.events[e];
            s && s.fire(t);
        }),
        (F.prototype.registerCallback = function (e) {
            this.callbacks.push(e);
        }),
        (F.prototype.unregisterCallback = function (e) {
            var t = this.callbacks.indexOf(e);
            t > -1 && this.callbacks.splice(t, 1);
        }),
        (F.prototype.fire = function (e) {
            this.callbacks.slice(0).forEach(function (t) {
                t(e);
            });
        }),
        (R.prototype.set = function (e, t) {
            if (this.count() >= this.bucketSize) {
                var s = this._keys.splice(0, 1);
                this.delete(s);
            }
            return this._keys.push(e), (this._store[e] = t), this._store;
        }),
        (R.prototype.get = function (e) {
            return this._store[e];
        }),
        (R.prototype.has = function (e) {
            return Boolean(this._store[e]);
        }),
        (R.prototype.count = function () {
            return Object.keys(this._store).length;
        }),
        (R.prototype.delete = function (e) {
            var t = Boolean(this._store[e]);
            return delete this._store[e], t && !this._store[e];
        });
    var B,
        q,
        N =
            ((B = function (e, t, s, n, i) {
                var o = new XMLHttpRequest(),
                    r = e + "/suggest.json";
                (o.onreadystatechange = function () {
                    if (o.readyState !== XMLHttpRequest.DONE);
                    else {
                        var e = o.getResponseHeader("Content-Type");
                        if (o.status >= 500) return void i(new L());
                        if (404 === o.status) return void i(new x(o.status));
                        if ("string" != typeof e || null === e.toLowerCase().match("application/json"))
                            return void i(new k(o.status));
                        if (417 === o.status) {
                            try {
                                var t = JSON.parse(o.responseText);
                                i(new C(o.status, t.message, t.description));
                            } catch (e) {
                                i(new T(o.status));
                            }
                            return;
                        }
                        if (422 === o.status) {
                            try {
                                var r = JSON.parse(o.responseText);
                                i(new M(o.status, r.message, r.description));
                            } catch (e) {
                                i(new T(o.status));
                            }
                            return;
                        }
                        if (429 === o.status) {
                            try {
                                var a = JSON.parse(o.responseText);
                                i(new I(o.status, a.message, a.description, o.getResponseHeader("Retry-After")));
                            } catch (e) {
                                i(new T(o.status));
                            }
                            return;
                        }
                        if (200 === o.status) {
                            try {
                                var l = JSON.parse(o.responseText);
                                (l.query = s), n(l);
                            } catch (e) {
                                i(new T(o.status));
                            }
                            return;
                        }
                        try {
                            var c = JSON.parse(o.responseText);
                            i(new A(o.status, c.message, c.description));
                        } catch (e) {
                            i(new T(o.status));
                        }
                    }
                }),
                    o.open("get", r + "?q=" + encodeURIComponent(s) + "&" + t),
                    o.setRequestHeader("Content-Type", "application/json"),
                    o.send();
            }),
            (q = null),
            function () {
                var e = this,
                    t = arguments;
                clearTimeout(q),
                    (q = setTimeout(function () {
                        (q = null), B.apply(e, t);
                    }, 10));
            });
    function $(e) {
        if (!e) throw new TypeError("No config object was specified");
        var t = e;
        (this._retryAfter = null),
            (this._currentQuery = null),
            (this.dispatcher = new O()),
            (this.cache = new R({ bucketSize: 40 })),
            (this.searchPath = t.search_path || "/search"),
            t.search_path && delete t.search_path,
            (this.configParams = D(t));
    }
    function P(e) {
        return "string" != typeof e ? null : e.trim().replace(" ", "-").toLowerCase();
    }
    ($.SEARCH_PATH = "/search"),
        ($.TYPES = { PRODUCT: "product", PAGE: "page", ARTICLE: "article", COLLECTION: "collection" }),
        ($.FIELDS = {
            AUTHOR: "author",
            BODY: "body",
            PRODUCT_TYPE: "product_type",
            TAG: "tag",
            TITLE: "title",
            VARIANTS_BARCODE: "variants.barcode",
            VARIANTS_SKU: "variants.sku",
            VARIANTS_TITLE: "variants.title",
            VENDOR: "vendor",
        }),
        ($.UNAVAILABLE_PRODUCTS = { SHOW: "show", HIDE: "hide", LAST: "last" }),
        ($.prototype.query = function (e) {
            try {
                !(function (e) {
                    var t;
                    if (null == e) throw (((t = new TypeError("'query' is missing")).type = "argument"), t);
                    if ("string" != typeof e)
                        throw (((t = new TypeError("'query' is not a string")).type = "argument"), t);
                })(e);
            } catch (e) {
                return void this.dispatcher.dispatch("error", e);
            }
            if ("" === e) return this;
            this._currentQuery = P(e);
            var t = this.cache.get(this._currentQuery);
            return t
                ? (this.dispatcher.dispatch("success", t), this)
                : (N(
                      this.searchPath,
                      this.configParams,
                      e,
                      function (e) {
                          this.cache.set(P(e.query), e),
                              P(e.query) === this._currentQuery &&
                                  ((this._retryAfter = null), this.dispatcher.dispatch("success", e));
                      }.bind(this),
                      function (e) {
                          e.retryAfter && (this._retryAfter = e.retryAfter), this.dispatcher.dispatch("error", e);
                      }.bind(this)
                  ),
                  this);
        }),
        ($.prototype.on = function (e, t) {
            return this.dispatcher.on(e, t), this;
        }),
        ($.prototype.off = function (e, t) {
            return this.dispatcher.off(e, t), this;
        });
    var V = {
        search_path: $.SEARCH_PATH,
        resources: {
            type: [$.TYPES.PRODUCT],
            options: {
                unavailable_products: $.UNAVAILABLE_PRODUCTS.LAST,
                fields: [$.FIELDS.TITLE, $.FIELDS.VENDOR, $.FIELDS.PRODUCT_TYPE, $.FIELDS.VARIANTS_TITLE],
            },
        },
    };
    function U(e) {
        if (
            !(
                e &&
                e.selectors &&
                e.selectors.input &&
                j(e.selectors.input) &&
                e.selectors.result &&
                j(e.selectors.result) &&
                e.resultTemplateFct &&
                K(e.resultTemplateFct) &&
                e.numberOfResultsTemplateFct &&
                K(e.numberOfResultsTemplateFct) &&
                e.loadingResultsMessageTemplateFct &&
                K(e.loadingResultsMessageTemplateFct)
            )
        ) {
            var t = new TypeError("PredictiveSearchComponent config is not valid");
            throw ((t.type = "argument"), t);
        }
        var s, n, i;
        (this.nodes =
            ((s = e.selectors),
            {
                input: document.querySelector(s.input),
                reset: document.querySelector(s.reset),
                result: document.querySelector(s.result),
            })),
            (i = this.nodes) && i.input && i.result && "INPUT" === i.input.tagName
                ? ((this._searchKeyword = ""),
                  (this.resultTemplateFct = e.resultTemplateFct),
                  (this.numberOfResultsTemplateFct = e.numberOfResultsTemplateFct),
                  (this.loadingResultsMessageTemplateFct = e.loadingResultsMessageTemplateFct),
                  (this.numberOfResults = e.numberOfResults || 4),
                  (this.classes = {
                      visibleVariant: e.visibleVariant ? e.visibleVariant : "predictive-search-wrapper--visible",
                      itemSelected: e.itemSelectedClass ? e.itemSelectedClass : "predictive-search-item--selected",
                      clearButtonVisible: e.clearButtonVisibleClass
                          ? e.clearButtonVisibleClass
                          : "predictive-search__clear-button--visible",
                  }),
                  (this.selectors = { searchResult: e.searchResult ? e.searchResult : "[data-search-result]" }),
                  (this.callbacks = (function (e) {
                      return {
                          onBodyMousedown: e.onBodyMousedown,
                          onBeforeOpen: e.onBeforeOpen,
                          onOpen: e.onOpen,
                          onBeforeClose: e.onBeforeClose,
                          onClose: e.onClose,
                          onInputFocus: e.onInputFocus,
                          onInputKeyup: e.onInputKeyup,
                          onInputBlur: e.onInputBlur,
                          onInputReset: e.onInputReset,
                          onBeforeDestroy: e.onBeforeDestroy,
                          onDestroy: e.onDestroy,
                      };
                  })(e)),
                  (n = this.nodes.input).setAttribute("autocorrect", "off"),
                  n.setAttribute("autocomplete", "off"),
                  n.setAttribute("autocapitalize", "off"),
                  n.setAttribute("spellcheck", "false"),
                  this._addInputEventListeners(),
                  this._addBodyEventListener(),
                  this._addAccessibilityAnnouncer(),
                  this._toggleClearButtonVisibility(),
                  (this.predictiveSearch = new $(e.PredictiveSearchAPIConfig ? e.PredictiveSearchAPIConfig : V)),
                  this.predictiveSearch.on("success", this._handlePredictiveSearchSuccess.bind(this)),
                  this.predictiveSearch.on("error", this._handlePredictiveSearchError.bind(this)))
                : console.warn("Could not find valid nodes");
    }
    function H(e) {
        return Object.prototype.toString.call(e);
    }
    function j(e) {
        return "[object String]" === H(e);
    }
    function z(e) {
        return "[object Boolean]" === H(e);
    }
    function K(e) {
        return "[object Function]" === H(e);
    }
    function Y() {
        const e = document.querySelector(".xo-predictive-search"),
            t = e?.dataset.locales;
        if (!t) throw new Error("Missing data-locales attribute");
        return l(t);
    }
    function X({ url: e, title: t }) {
        return `\n    <a href="${e}" data-search-result class='xo-predictive-search__item'>\n      <span>${t}</span>\n    </a>\n  `;
    }
    function J({ url: e, title: t }) {
        return `\n    <a href="${e}" data-search-result class='xo-predictive-search__item'>\n      <span>${t}</span>\n    </a>\n  `;
    }
    function W({ url: e, image: t, title: s, vendor: n, price: i, available: av, compare_at_price_min: cpMin, compare_at_price_max: cpMax, tags: tg }) {
        let o, r, a;
        o = show_currency_code ? "inline-block" : "none";
        r = show_vendor ? "block" : "none";
        a = show_price ? "flex" : "none";

        // Badge logic: sold-out > hide-price > sale
        const hidePrice = tg && tg.some(function(tag) { return tag.toLowerCase() === "hide-price"; });
        const isSoldOut = av === false;
        const isOnSale = cpMin && parseFloat(cpMin) > 0 && parseFloat(cpMin) > parseFloat(i);

        let badgeHtml = "";
        if (isSoldOut) {
            badgeHtml = '<div class="xo-badge-sold-out"><span class="xo-badge-sold-out__title">' + (window.__badgeSoldOutText || "Sold out") + '</span></div>';
        } else if (hidePrice) {
            badgeHtml = '<div class="xo-badge-sold-out"><span class="xo-badge-sold-out__title">Contact For Price</span></div>';
        } else if (isOnSale) {
            badgeHtml = '<div class="xo-product-card__badge"><div class="xo-badge-sale">' + (window.__badgeSaleText || "Sale") + '</div></div>';
        }

        // Price HTML - no currency code (SGD)
        let priceHtml = "";
        if (hidePrice) {
            priceHtml = "";
        } else if (isOnSale) {
            priceHtml = `<div class='xo-predictive-search__product-price' style='display:${a}'><span class="xo-price__item xo-price__item--accent">${currency_symbol}${i}</span><span class="xo-price__item xo-price__item--del" style="text-decoration:line-through;opacity:0.6;margin-left:0.4rem;">${currency_symbol}${cpMin}</span></div>`;
        } else {
            priceHtml = `<div class='xo-predictive-search__product-price' style='display:${a}'><span>${currency_symbol}${i}</span></div>`;
        }

        return (
            `\n    <a href="${e}" data-search-result class='xo-predictive-search__item' style="position:relative">\n      <div style="position:relative;overflow:hidden"><img src="${t}" alt="${s}" class='xo-predictive-search__item-image'/>${badgeHtml}</div>\n      <div>\n        <div class='xo-predictive-search__product-title'>${s}</div>\n        <div class='xo-predictive-search__product-vendor' style='display:${r}'>${n}</div>\n        ${priceHtml}\n      </div>\n    </a>\n  `
        );
    }
    function Q({ url: e, image: t, title: s }) {
        return `\n    <a href="${e}" data-search-result class='xo-predictive-search__item'>\n      <img src="${t}" alt="${s}" class='xo-predictive-search__item-image'/>\n      <span class='xo-predictive-search__article-title'>${s}</span>\n    </a>\n  `;
    }
    (U.prototype.isResultVisible = !1),
        (U.prototype.results = {}),
        (U.prototype._latencyTimer = null),
        (U.prototype._resultNodeClicked = !1),
        (U.prototype._addInputEventListeners = function () {
            var e = this.nodes.input,
                t = this.nodes.reset;
            e &&
                ((this._handleInputFocus = this._handleInputFocus.bind(this)),
                (this._handleInputBlur = this._handleInputBlur.bind(this)),
                (this._handleInputKeyup = this._handleInputKeyup.bind(this)),
                (this._handleInputKeydown = this._handleInputKeydown.bind(this)),
                e.addEventListener("focus", this._handleInputFocus),
                e.addEventListener("blur", this._handleInputBlur),
                e.addEventListener("keyup", this._handleInputKeyup),
                e.addEventListener("keydown", this._handleInputKeydown),
                t &&
                    ((this._handleInputReset = this._handleInputReset.bind(this)),
                    t.addEventListener("click", this._handleInputReset)));
        }),
        (U.prototype._removeInputEventListeners = function () {
            var e = this.nodes.input;
            e.removeEventListener("focus", this._handleInputFocus),
                e.removeEventListener("blur", this._handleInputBlur),
                e.removeEventListener("keyup", this._handleInputKeyup),
                e.removeEventListener("keydown", this._handleInputKeydown);
        }),
        (U.prototype._addBodyEventListener = function () {
            (this._handleBodyMousedown = this._handleBodyMousedown.bind(this)),
                document.querySelector("body").addEventListener("mousedown", this._handleBodyMousedown);
        }),
        (U.prototype._removeBodyEventListener = function () {
            document.querySelector("body").removeEventListener("mousedown", this._handleBodyMousedown);
        }),
        (U.prototype._removeClearButtonEventListener = function () {
            var e = this.nodes.reset;
            e && e.removeEventListener("click", this._handleInputReset);
        }),
        (U.prototype._handleBodyMousedown = function (e) {
            if (this.isResultVisible && null !== this.nodes)
                if (
                    e.target.isEqualNode(this.nodes.input) ||
                    this.nodes.input.contains(e.target) ||
                    e.target.isEqualNode(this.nodes.result) ||
                    this.nodes.result.contains(e.target)
                )
                    this._resultNodeClicked = !0;
                else if (K(this.callbacks.onBodyMousedown)) {
                    var t = this.callbacks.onBodyMousedown(this.nodes);
                    z(t) && t && this.close();
                } else this.close();
        }),
        (U.prototype._handleInputFocus = function (e) {
            if (K(this.callbacks.onInputFocus)) {
                var t = this.callbacks.onInputFocus(this.nodes);
                if (z(t) && !t) return !1;
            }
            return e.target.value.length > 0 && this._search(), !0;
        }),
        (U.prototype._handleInputBlur = function () {
            return (
                setTimeout(
                    function () {
                        if (K(this.callbacks.onInputBlur)) {
                            var e = this.callbacks.onInputBlur(this.nodes);
                            if (z(e) && !e) return !1;
                        }
                        return (
                            !document.activeElement.isEqualNode(this.nodes.reset) &&
                            (this._resultNodeClicked ? ((this._resultNodeClicked = !1), !1) : void this.close())
                        );
                    }.bind(this)
                ),
                !0
            );
        }),
        (U.prototype._addAccessibilityAnnouncer = function () {
            (this._accessibilityAnnouncerDiv = window.document.createElement("div")),
                this._accessibilityAnnouncerDiv.setAttribute(
                    "style",
                    "position: absolute !important; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;"
                ),
                this._accessibilityAnnouncerDiv.setAttribute("data-search-announcer", ""),
                this._accessibilityAnnouncerDiv.setAttribute("aria-live", "polite"),
                this._accessibilityAnnouncerDiv.setAttribute("aria-atomic", "true"),
                this.nodes.result.parentElement.appendChild(this._accessibilityAnnouncerDiv);
        }),
        (U.prototype._removeAccessibilityAnnouncer = function () {
            this.nodes.result.parentElement.removeChild(this._accessibilityAnnouncerDiv);
        }),
        (U.prototype._updateAccessibilityAttributesAfterSelectingElement = function (e, t) {
            this.nodes.input.setAttribute("aria-activedescendant", t.id),
                e && e.removeAttribute("aria-selected"),
                t.setAttribute("aria-selected", !0);
        }),
        (U.prototype._clearAriaActiveDescendant = function () {
            this.nodes.input.setAttribute("aria-activedescendant", "");
        }),
        (U.prototype._announceNumberOfResultsFound = function (e) {
            var t = this._accessibilityAnnouncerDiv.innerHTML,
                s = this.numberOfResultsTemplateFct(e);
            t === s && (s += "&nbsp;"), (this._accessibilityAnnouncerDiv.innerHTML = s);
        }),
        (U.prototype._announceLoadingState = function () {
            this._accessibilityAnnouncerDiv.innerHTML = this.loadingResultsMessageTemplateFct();
        }),
        (U.prototype._handleInputKeyup = function (e) {
            if (K(this.callbacks.onInputKeyup)) {
                var t = this.callbacks.onInputKeyup(this.nodes);
                if (z(t) && !t) return !1;
            }
            if ((this._toggleClearButtonVisibility(), this.isResultVisible && null !== this.nodes)) {
                if (38 === e.keyCode) return this._navigateOption(e, "UP"), !0;
                if (40 === e.keyCode) return this._navigateOption(e, "DOWN"), !0;
                if (13 === e.keyCode) return this._selectOption(), !0;
                27 === e.keyCode && this.close();
            }
            return (
                e.target.value.length <= 0
                    ? (this.close(), this._setKeyword(""))
                    : e.target.value.length > 0 && this._search(),
                !0
            );
        }),
        (U.prototype._handleInputKeydown = function (e) {
            13 === e.keyCode && null != this._getSelectedOption() && e.preventDefault(),
                (38 !== e.keyCode && 40 !== e.keyCode) || e.preventDefault();
        }),
        (U.prototype._handleInputReset = function (e) {
            if ((e.preventDefault(), K(this.callbacks.onInputReset))) {
                var t = this.callbacks.onInputReset(this.nodes);
                if (z(t) && !t) return !1;
            }
            return (
                (this.nodes.input.value = ""),
                this.nodes.input.focus(),
                this._toggleClearButtonVisibility(),
                this.close(),
                !0
            );
        }),
        (U.prototype._navigateOption = function (e, t) {
            var s = this._getSelectedOption();
            if (s)
                if ("DOWN" === t) {
                    var n = s.nextElementSibling;
                    n &&
                        (s.classList.remove(this.classes.itemSelected),
                        n.classList.add(this.classes.itemSelected),
                        this._updateAccessibilityAttributesAfterSelectingElement(s, n));
                } else {
                    var i = s.previousElementSibling;
                    i &&
                        (s.classList.remove(this.classes.itemSelected),
                        i.classList.add(this.classes.itemSelected),
                        this._updateAccessibilityAttributesAfterSelectingElement(s, i));
                }
            else {
                var o = this.nodes.result.querySelector(this.selectors.searchResult);
                o.classList.add(this.classes.itemSelected),
                    this._updateAccessibilityAttributesAfterSelectingElement(null, o);
            }
        }),
        (U.prototype._getSelectedOption = function () {
            return this.nodes.result.querySelector("." + this.classes.itemSelected);
        }),
        (U.prototype._selectOption = function () {
            var e = this._getSelectedOption();
            e && e.querySelector("a, button").click();
        }),
        (U.prototype._search = function () {
            var e = this.nodes.input.value;
            this._searchKeyword !== e &&
                (clearTimeout(this._latencyTimer),
                (this._latencyTimer = setTimeout(
                    function () {
                        (this.results.isLoading = !0),
                            this._announceLoadingState(),
                            this.nodes.result.classList.add(this.classes.visibleVariant),
                            (this.nodes.result.innerHTML = this.resultTemplateFct(this.results));
                    }.bind(this),
                    500
                )),
                this.predictiveSearch.query(e),
                this._setKeyword(e));
        }),
        (U.prototype._handlePredictiveSearchSuccess = function (e) {
            clearTimeout(this._latencyTimer),
                (this.results = e.resources.results),
                (this.results.isLoading = !1),
                (this.results.products = this.results.products.slice(0, this.numberOfResults)),
                (this.results.canLoadMore = this.numberOfResults <= this.results.products.length),
                (this.results.searchQuery = this.nodes.input.value),
                this.results.products.length > 0 || this.results.searchQuery
                    ? ((this.nodes.result.innerHTML = this.resultTemplateFct(this.results)),
                      this._announceNumberOfResultsFound(this.results),
                      this.open())
                    : ((this.nodes.result.innerHTML = ""), this._closeOnNoResults());
        }),
        (U.prototype._handlePredictiveSearchError = function () {
            clearTimeout(this._latencyTimer), (this.nodes.result.innerHTML = ""), this._closeOnNoResults();
        }),
        (U.prototype._closeOnNoResults = function () {
            this.nodes && this.nodes.result.classList.remove(this.classes.visibleVariant), (this.isResultVisible = !1);
        }),
        (U.prototype._setKeyword = function (e) {
            this._searchKeyword = e;
        }),
        (U.prototype._toggleClearButtonVisibility = function () {
            this.nodes.reset &&
                (this.nodes.input.value.length > 0
                    ? this.nodes.reset.classList.add(this.classes.clearButtonVisible)
                    : this.nodes.reset.classList.remove(this.classes.clearButtonVisible));
        }),
        (U.prototype.open = function () {
            if (!this.isResultVisible) {
                if (K(this.callbacks.onBeforeOpen)) {
                    var e = this.callbacks.onBeforeOpen(this.nodes);
                    if (z(e) && !e) return !1;
                }
                return (
                    this.nodes.result.classList.add(this.classes.visibleVariant),
                    this.nodes.input.setAttribute("aria-expanded", !0),
                    (this.isResultVisible = !0),
                    (K(this.callbacks.onOpen) && this.callbacks.onOpen(this.nodes)) || !0
                );
            }
        }),
        (U.prototype.close = function () {
            if (!this.isResultVisible) return !0;
            if (K(this.callbacks.onBeforeClose)) {
                var e = this.callbacks.onBeforeClose(this.nodes);
                if (z(e) && !e) return !1;
            }
            return (
                this.nodes && this.nodes.result.classList.remove(this.classes.visibleVariant),
                this.nodes.input.setAttribute("aria-expanded", !1),
                this._clearAriaActiveDescendant(),
                this._setKeyword(""),
                K(this.callbacks.onClose) && this.callbacks.onClose(this.nodes),
                (this.isResultVisible = !1),
                (this.results = {}),
                !0
            );
        }),
        (U.prototype.destroy = function () {
            if ((this.close(), K(this.callbacks.onBeforeDestroy))) {
                var e = this.callbacks.onBeforeDestroy(this.nodes);
                if (z(e) && !e) return !1;
            }
            var t;
            return (
                this.nodes.result.classList.remove(this.classes.visibleVariant),
                (t = this.nodes.input).removeAttribute("autocorrect", "off"),
                t.removeAttribute("autocomplete", "off"),
                t.removeAttribute("autocapitalize", "off"),
                t.removeAttribute("spellcheck", "false"),
                this._removeInputEventListeners(),
                this._removeBodyEventListener(),
                this._removeAccessibilityAnnouncer(),
                this._removeClearButtonEventListener(),
                K(this.callbacks.onDestroy) && this.callbacks.onDestroy(this.nodes),
                !0
            );
        }),
        (U.prototype.clearAndClose = function () {
            (this.nodes.input.value = ""), this.close();
        });
    const G = new U({
            selectors: {
                input: '[data-predictive-search-input="header"]',
                reset: '[data-predictive-search-reset="header"]',
                result: '[data-predictive-search-result="header"]',
            },
            PredictiveSearchAPIConfig: {
                search_path: "/search",
                resources: {
                    type: ["product", "article", "page", "collection"],
                    options: {
                        unavailable_products: "last",
                        fields: ["title", "vendor", "product_type", "variants.title"],
                    },
                },
            },
            resultTemplateFct: function (e) {
                return e?.products.length > 0 ||
                    e?.articles.length > 0 ||
                    e?.pages.length > 0 ||
                    e?.collections.length > 0
                    ? `\n    <div class="xo-predictive-search__inner">\n      <xo-container>\n        <xo-grid>\n          ${(function (
                          e
                      ) {
                          return e?.collections.length > 0 || e?.pages.length > 0
                              ? `\n    <div style="${(function (e) {
                                    return e?.products.length > 0 || e?.articles.length > 0
                                        ? "--xs: 12; --sm: 4; --md: 4"
                                        : "--xs: 12; --sm: 6; --md: 12";
                                })(e)}">\n      ${(function (e) {
                                    return e?.collections.length > 0
                                        ? `\n    <h3>${Y().collections}</h3>\n    <div class='xo-predictive-search__item-list xo-predictive-search__item-list--article'>\n      ${e.collections.map(J).join("")}\n    </div>\n  `
                                        : "";
                                })(e)}\n      ${(function (e) {
                                    return e?.pages.length > 0
                                        ? `\n    <h3>${Y().pages}</h3>\n    <div class='xo-predictive-search__item-list'>\n      ${e.pages.map(X).join("")}\n    </div>\n  `
                                        : "";
                                })(e)}\n    </div>\n  `
                              : "";
                      })(e)}\n          ${(function (e) {
                          return e?.products.length > 0
                              ? `\n    <div style="${(function (e) {
                                    return e?.pages.length > 0 || e?.collections.length > 0
                                        ? e?.articles.length > 0
                                            ? "--xs: 12; --sm: 4; --md: 4"
                                            : "--xs: 12; --sm: 8; --md: 8"
                                        : "--xs: 12; --sm: 6; --md: 12";
                                })(
                                    e
                                )}">\n      <h3>${Y().products}</h3>\n      <xo-grid style='--col-width: 15rem' class='xo-predictive-search__item-list'>\n        ${e.products.map(W).join("")}\n      </xo-grid>\n    </div>\n  `
                              : "";
                      })(e)}\n          ${(function (e) {
                          return e?.articles.length > 0
                              ? `\n    <div style="${(function (e) {
                                    return e?.pages.length > 0 || e?.collections.length > 0
                                        ? e?.products.length > 0
                                            ? "--xs: 12; --sm: 4; --md: 4"
                                            : "--xs: 12; --sm: 8; --md: 8"
                                        : "--xs: 12; --sm: 6; --md: 12";
                                })(
                                    e
                                )}">\n    <h3>${Y().articles}</h3>\n      <xo-grid style='--col-width: 15rem' class='xo-predictive-search__item-list'>\n        ${e.articles.map(Q).join("")}\n      </xo-grid>\n    </div>\n  `
                              : "";
                      })(e)}\n        </xo-grid>\n      </xo-container>\n    </div>\n  `
                    : "";
            },
            numberOfResultsTemplateFct: (e) =>
                1 === e.products.length
                    ? "one result found"
                    : "[results_count] results found".replace("[results_count]", `${e.products.length}`),
            loadingResultsMessageTemplateFct: () => "loading",
            onInputFocus: (e) => {
                e.input.value && G.open();
            },
            onInputKeyup: () => !0,
            onInputBlur: () => !1,
        }),
        Z = "xo-copy";
    class ee extends HTMLElement {
        static defaultOptions = { xoUrl: "" };
        get options() {
            const e = (function (e, { pick: t, types: s, camelCase: n = !0, propTransformer: i } = {}) {
                let o = {};
                if (null == e) return o;
                const r = Array.from(e.attributes);
                null == t &&
                    (t = (function (e) {
                        const t = [];
                        for (let s = 0; s < e.length; s++) t.push(e[s].name);
                        return t;
                    })(r));
                for (const e of r) {
                    let r = n ? a(e.name) : e.name;
                    const l = s?.[r];
                    null != e.value &&
                        t?.includes(r) &&
                        ("function" == typeof i && (r = i(r)),
                        (o = s && null != l ? { ...o, [r]: c(e.value, l) } : { ...o, [r]: e.value }));
                }
                return o;
            })(this, { pick: ["xoUrl"], types: { xoUrl: "string" } });
            return { ...ee.defaultOptions, ...e };
        }
        handleClick = async () => {
            try {
                const { options: e } = this,
                    { xoUrl: t } = e;
                await navigator.clipboard.writeText(t), xoToast({ name: "share-copy" });
            } catch (e) {
                console.error(e);
            }
        };
        connectedCallback() {
            this.addEventListener("click", this.handleClick);
        }
        disconnectedCallback() {
            this.removeEventListener("click", this.handleClick);
        }
    }
    i({ [Z]: ee });
    const te = "xo-address-form",
        se = "edit-address-";
    class ne extends HTMLElement {
        unsubscribe = () => {};
        addressId = "";
        selectCountryEl = null;
        connectedCallback() {
            this.unsubscribe = xoStore.subscribe("xo-modal", ({ data: e }) => {
                const t = ((s = e), Object.values(s)).find((e) => e.isOpen);
                var s;
                t &&
                    t.isOpen &&
                    (t.options.xoName?.includes(se)
                        ? ((this.addressId = t.options.xoName.replace(se, "")), this.bindCountry())
                        : "create-address" === t.options.xoName && ((this.addressId = "new"), this.bindCountry()));
            });
        }
        bindCountry = () => {
            this.selectCountryEl = document.querySelector(
                `select[name="address[country]"][data-country-id="${this.addressId}"]`
            );
            const e = this.selectCountryEl?.getAttribute("data-default"),
                t = this.selectCountryEl?.querySelector(`option[value="${e}"]`);
            if (t) {
                t.setAttribute("selected", "selected");
                const e = this.getProvinces(t);
                this.renderProvinces(e);
            }
            const s = document.querySelector(`select[name="address[province]"][data-province-id="${this.addressId}"]`),
                n = s?.getAttribute("data-default"),
                i = s?.querySelector(`option[value="${n}"]`);
            i && i.setAttribute("selected", "selected"),
                this.selectCountryEl?.addEventListener("change", this.handleCountryChange);
        };
        getProvinces = (e) => l(e.getAttribute("data-provinces") ?? "[]");
        handleCountryChange = (e) => {
            const t = e.target,
                s = t.querySelector(`option[value="${t.value}"]`);
            if (s) {
                const e = this.getProvinces(s);
                this.renderProvinces(e);
            }
        };
        renderProvinces = (e) => {
            const t = document.querySelector(`select[name="address[province]"][data-province-id="${this.addressId}"]`);
            if (t) {
                t.innerHTML = e.map(([e, t]) => `<option value="${e}">${t}</option>`).join("");
                const s = t.closest(".js-address-province"),
                    n = e.length > 0;
                s && (n ? s.classList.remove("hide") : s.classList.add("hide"));
            }
        };
        disconnectedCallback() {
            this.unsubscribe(), this.selectCountryEl?.removeEventListener("change", this.handleCountryChange);
        }
    }
    i({ [te]: ne }), s(208);
    const ie = window.Shopify;
    class oe {
        productInfoEl;
        productDataEl;
        productData;
        CAROUSEL_NAME = window.innerWidth > 767 ? "product-information-desktop" : "product-information-mobile";
        variantSelected = {};
        cartFormUnsubscribe = () => {};
        constructor(e) {
            (this.productInfoEl = document.querySelector(e)),
                (this.productDataEl = this.productInfoEl?.querySelector("xo-product-data script")),
                (this.productData = l(this.productDataEl?.textContent ?? ""));
        }
        getMediaId() {
            const e = Object.values(this.variantSelected || {});
            let t = this.productData.variants.find((t) => JSON.stringify(t.options.sort()) === JSON.stringify(e.sort()))
                ?.featured_media?.id;
            return t || (t = this.productData.variants.find((e) => e.featured_media)?.featured_media?.id), t;
        }
        handleCarousel(e) {
            const t = Array.from(
                    this.productInfoEl?.querySelectorAll(
                        `xo-carousel[xo-name*="${this.CAROUSEL_NAME}"] xo-carousel-slide[data-media-id]:not([xo-cloned])`
                    ) ?? []
                ),
                s = t.findIndex((t) => t.getAttribute("data-media-id") === e?.toString()),
                n = t?.[0]?.closest(`xo-carousel[xo-name*="${this.CAROUSEL_NAME}"]`),
                i = n?.getAttribute("xo-name");
            i && xoCarousel.goTo(i, s);
        }
        handleScrollTo(e) {
            const t = this.productInfoEl?.querySelector(`xo-animate[data-media-id="${e}"]`);
            if (t) {
                const { top: e } = d(t);
                window.scrollTo({ top: e, behavior: "smooth" });
            }
        }
        init() {
            this.cartFormUnsubscribe = cartFormSubscribe(() => {
                const e = this.productInfoEl?.getAttribute("xo-section-id"),
                    t = this.productInfoEl?.getAttribute("xo-product-id"),
                    s = `${e}/${t}`,
                    n = getCartFormState()?.[s];
                if (n) {
                    const e = n.variantSelected;
                    if (JSON.stringify(e) !== JSON.stringify(this.variantSelected)) {
                        this.variantSelected = e;
                        const t = this.getMediaId();
                        this.handleCarousel(t), this.handleScrollTo(t);
                    }
                }
            });
        }
        unsubscribe = () => {
            this.cartFormUnsubscribe();
        };
    }
    class re extends HTMLElement {
        modelViewerUI;
        constructor() {
            super();
            const e = this.querySelector(".xb-product-model__poster");
            e && e.addEventListener("click", this.loadContent.bind(this));
        }
        loadContent() {
            if (!this.getAttribute("loaded")) {
                const e = document.createElement("div"),
                    t = this.querySelector("template");
                if (t) {
                    const s = t.content.firstElementChild;
                    s && e.appendChild(s.cloneNode(!0));
                }
                this.setAttribute("loaded", "true");
                const s = e.querySelector("model-viewer");
                s && this.appendChild(s).focus();
            }
            ie.loadFeatures([{ name: "model-viewer-ui", version: "1.0", onLoad: this.setupModelViewerUI.bind(this) }]);
        }
        setupModelViewerUI(e) {
            e || (this.modelViewerUI = new ie.ModelViewerUI(this.querySelector("model-viewer")));
        }
    }
    window.customElements.define("xo-product-model", re);
    class ae {
        TERMS_NAME = "@term";
        inputPolicyEls = document.querySelectorAll(".xo-field-checkbox__input[name='agree_policy'][type='checkbox']");
        constructor() {
            this.init();
        }
        setTerms = (e) => {
            localStorage.setItem(this.TERMS_NAME, e ? "true" : "false");
        };
        getTerms = () => {
            const e = localStorage.getItem(this.TERMS_NAME);
            return null != e && "true" === e;
        };
        handleChange = (e) => {
            const t = e.target;
            this.setTerms(t.checked), this.termsBinding();
        };
        termsBinding = () => {
            const e = document.querySelectorAll(".terms-binding"),
                t = this.getTerms();
            e.forEach((e) => {
                t ? e.classList.remove("disabled-button") : e.classList.add("disabled-button");
            });
        };
        setDefaultChecked = (e) => {
            e.checked = this.getTerms();
        };
        init() {
            this.inputPolicyEls.length > 0 &&
                (this.inputPolicyEls.forEach((e) => {
                    e.addEventListener("input", this.handleChange), this.setDefaultChecked(e);
                }),
                this.termsBinding());
        }
    }
    const le = new oe("xo-product[xo-product-information]");
    le.init(), new ae();
    const ce = document.querySelector('xo-modal[xo-name="quick-view"]');
    ce &&
        new MutationObserver(() => {
            const e = new oe("xo-product-quick-view xo-product[xo-product-information]");
            var t, s;
            (s = "xo-active"),
                "false" !== (t = ce).getAttribute(s) && t.hasAttribute(s)
                    ? (e.init(), le.unsubscribe(), new ae())
                    : (le.init(), e.unsubscribe());
        }).observe(ce, { attributes: !0, attributeFilter: ["xo-active"] });
})();
